import { LEVEL_1 } from './level_1'
import { LEVEL_2 } from './level_2'
import { LEVEL_3 } from './level_3'
import { LEVEL_4 } from './level_4'
import { LEVEL_5 } from './level_5'
import { LEVEL_6 } from './level_6'
import { LEVEL_7 } from './level_7'
import { LEVEL_8 } from './level_8'
import { LEVEL_9 } from './level_9'
import { LEVEL_10 } from './level_10'
import { LEVEL_11 } from './level_11'
import { LEVEL_12 } from './level_12'
import { STAGE_1 } from './stage_1'
import { STAGE_2 } from './stage_2'
import { LEVEL_13 } from './level_13'
import { LEVEL_14 } from './level_14'
import { LEVEL_15 } from './level_15'
import { LEVEL_16 } from './level_16'
import { STAGE_3 } from './stage_3'
import { LEVEL_17 } from './level_17'
import { LEVEL_18 } from './level_18'
import { LEVEL_19 } from './level_19'
import { LEVEL_20 } from './level_20'
import { LEVEL_21 } from './level_21'

export const LEVEL_LIST = [
  STAGE_1,
  STAGE_2,
  STAGE_3,
  LEVEL_1,
  LEVEL_2,
  LEVEL_3,
  LEVEL_4,
  LEVEL_5,
  LEVEL_6,
  LEVEL_7,
  LEVEL_8,
  LEVEL_9,
  LEVEL_10,
  LEVEL_11,
  LEVEL_12,
  LEVEL_13,
  LEVEL_14,
  LEVEL_15,
  LEVEL_16,
  LEVEL_17,
  LEVEL_18,
  LEVEL_19,
  LEVEL_20,
  LEVEL_21,
]
